"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAlignMobileHorizontalTableRows = void 0;
var _react = require("react");
var _useDebounce = require("use-debounce");
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var eventListenerInitialized = false;

/**
 * 
 * @param {*} param0 
 * @returns 
 */
var useAlignHorizontalMobileTables = exports.useAlignMobileHorizontalTableRows = function useAlignHorizontalMobileTables(_ref) {
  var _ref$currentLayout = _ref.currentLayout,
    currentLayout = _ref$currentLayout === void 0 ? 'stacked' : _ref$currentLayout,
    _ref$productTablesCon = _ref.productTablesContainerRef,
    productTablesContainerRef = _ref$productTablesCon === void 0 ? null : _ref$productTablesCon;
  var throttledAlignTableRows = (0, _useDebounce.useThrottledCallback)(function () {
    alignTableRows();
  }, 50);
  var getResizableHeightEachTable = (0, _react.useCallback)(function (productTables) {
    return productTables.reduce(function (maxHeightsSoFar, table) {
      var extraSpaceForLineHeight = 5;
      var rows = Array.from(table.querySelectorAll('tr'));
      var elementsByRows = rows.map(function (row) {
        return Array.from(row.querySelectorAll('th > *, td > *'));
      });
      var paddingHeightByRow = rows.map(function (row) {
        var maxPaddingTop = Array.from(row.children).map(function (child) {
          return window.getComputedStyle(child);
        }).reduce(function (acc, current) {
          return Math.max(acc, parseInt(current.paddingTop, 10));
        }, 0);
        var maxPaddingBottom = Array.from(row.children).map(function (child) {
          return window.getComputedStyle(child);
        }).reduce(function (acc, current) {
          return Math.max(acc, parseInt(current.paddingBottom, 10));
        }, 0);
        return maxPaddingTop + maxPaddingBottom;
      });
      var heights = elementsByRows.map(function (elements, index) {
        var paddingHeight = paddingHeightByRow[index];
        return Math.max.apply(Math, _toConsumableArray(elements.map(function (element) {
          return element.offsetHeight + paddingHeight + extraSpaceForLineHeight;
        })));
      });
      if (maxHeightsSoFar.length === 0) {
        return heights;
      }
      var newMaxHeights = maxHeightsSoFar.map(function (height, index) {
        return Math.max(height, heights[index]);
      });
      return newMaxHeights;
    }, []);
  }, []);
  var alignTableRows = (0, _react.useCallback)(function () {
    var container = productTablesContainerRef.current;
    if (!container || currentLayout !== 'horizontal') {
      return;
    }
    var productTables = Array.from(container.querySelectorAll('li table'));
    var resizableHeight = getResizableHeightEachTable(productTables);
    setTimeout(function () {
      productTables.forEach(function (table) {
        var rows = Array.from(table.querySelectorAll('tr'));
        rows.forEach(function (row, index) {
          var maxHeight = resizableHeight[index];
          row.style.height = "".concat(maxHeight, "px");
        });
      }, 100);
    });
  }, [productTablesContainerRef, currentLayout, getResizableHeightEachTable]);
  (0, _react.useEffect)(function () {
    if (currentLayout === 'horizontal') {
      if (!eventListenerInitialized) {
        window.addEventListener('resize', function () {
          return throttledAlignTableRows();
        });
        eventListenerInitialized = true;
      }
      if (productTablesContainerRef.current) {
        alignTableRows();
      }
    }
  }, [currentLayout, alignTableRows, throttledAlignTableRows, productTablesContainerRef]);
};